import React, { BaseSyntheticEvent } from 'react';
import { Form, Image } from 'react-bootstrap';
import '../assets/style/Pagination.css';
import { Label } from 'reactstrap';
import LeftWhite from '../assets/img/page-left-white.svg';
import RightWhite from '../assets/img/page-right-white.svg';
import LeftBlack from '../assets/img/page-left-black.svg';
import RightBlack from '../assets/img/page-right-black.svg';

interface IPaginationProps {
  pageSize: number;
  totalPages: number;
  currentPage: number;
  fromItem: number;
  toItem: number;
  totalItems: number;
  onSizeChange: (pageSize: number) => void;
  onPageChange: (currentPage: number) => void;
  showSelectLimit?: boolean;
}

const KPagination: React.FunctionComponent<IPaginationProps> = ({
  pageSize,
  currentPage,
  fromItem,
  toItem,
  totalItems,
  onSizeChange,
  onPageChange,
  showSelectLimit = true,
}) => {
  const sizeChange = (event: BaseSyntheticEvent) => {
    onSizeChange(event.target.value);
    onPageChange(1);
  };
  return (
    <div className="d-flex justify-content-end pagination-bg">
      {showSelectLimit && (
        <>
          <Label className="pagination-label me-4 pagination-text-mobile">
            Select Limit:{' '}
          </Label>
          <Form>
            <div className="page-count-parent">
              <Form.Check
                inline
                label="20"
                value="20"
                name="pagenationGroup"
                type="radio"
                id={`inline-radio-1`}
                defaultChecked={pageSize === 20}
                className="me-4 pagination-label"
                onChange={sizeChange}
              />
              <Form.Check
                inline
                label="50"
                value="50"
                defaultChecked={pageSize === 50}
                name="pagenationGroup"
                type="radio"
                id={`inline-radio-2`}
                className="me-4 pagination-label "
                onChange={sizeChange}
              />
              <Form.Check
                inline
                label="100"
                value="100"
                type="radio"
                defaultChecked={pageSize === 100}
                name="pagenationGroup"
                id={`inline-radio-3`}
                className="me-4 pagination-label cp"
                onChange={sizeChange}
              />
            </div>
          </Form>
        </>
      )}
      <Label className="pagination-label ms-1 me-3 pagination-text-mobile">
        Showing Records From:{' '}
      </Label>
      <Image
        alt="left"
        src={`${fromItem > 1 ? LeftBlack : LeftWhite}`}
        className={fromItem > 1 ? 'cursor-pointer' : ''}
        onClick={() => {
          if (fromItem > 1) {
            onPageChange(currentPage - 1);
          }
        }}
      />
      <Label className="pagination-label ms-2 me-2">
        {fromItem}-{toItem}
      </Label>
      <Image
        alt="right"
        src={`${toItem < totalItems ? RightBlack : RightWhite}`}
        className={`${toItem < totalItems ? 'cursor-pointer' : ''} me-2`}
        onClick={() => {
          if (toItem < totalItems) {
            onPageChange(currentPage + 1);
          }
        }}
      />
    </div>
  );
};

export default KPagination;
